import React from 'react'

type Props = {
  className?: string
}

const Connect = ({ className }: Props) => (
  <svg width="64" height="65" viewBox="0 0 64 65" fill="none" className={className}>
    <rect y="0.702637" width="64" height="64" rx="20" fill="#D8E6FF" />
    <path
      d="M44 32.036C44.0046 33.7958 43.5934 35.5318 42.8 37.1026C41.8592 38.985 40.413 40.5682 38.6233 41.675C36.8335 42.7818 34.771 43.3685 32.6667 43.3693C30.9068 43.3739 29.1708 42.9627 27.6 42.1693L20 44.7026L22.5333 37.1026C21.7399 35.5318 21.3287 33.7958 21.3333 32.036C21.3341 29.9317 21.9208 27.8691 23.0276 26.0794C24.1344 24.2896 25.7177 22.8434 27.6 21.9026C29.1708 21.1092 30.9068 20.6981 32.6667 20.7026H33.3333C36.1125 20.856 38.7374 22.029 40.7055 23.9971C42.6737 25.9653 43.8467 28.5902 44 31.3693V32.036Z"
      stroke="#2979FF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default Connect
